import React, { useContext, useEffect, useState } from "react";
import { BsBoxArrowUpRight } from "react-icons/bs";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { server } from "../../common";
import { Modal } from "react-bootstrap";
import { Button, TextField } from "@mui/material";
import Radio from "@mui/joy/Radio";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import RadioGroup from "@mui/joy/RadioGroup";
import Textarea from "@mui/joy/Textarea";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelectAccess } from "../../store/stateFunctions";
import configContext from "../../context/configContext/configContext";

const initialValues = {
  letter_description: "",
  availability: "",
  images: null,
};

const InternshipDetails = () => {
  document.title = "Internship";
  const user = useSelectAccess("Student");
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);
  const closeModal = () => setShow(false);
  const isLoggedIn = user && user;
  const navigate = useNavigate();

  const handleApplyNowClick = () => {
    if (isLoggedIn) {
      setShow(true);
    } else {
      toast.info("Please log in to apply for the internship");
      navigate("/loginstudent");
    }
  };

  useEffect(() => {
    server
      .get(`/internship/getinternship/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {});
  }, [id]);

  const {
    values,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      letter_description: Yup.string().required(
        "Please Enter Short Description"
      ),
      availability: Yup.string().required("Please Select You Availability"),
      images: Yup.mixed().test(
        "fileSize",
        "File size is too large",
        (value) => {
          return value ? value.size <= 5000000 : true;
        }
      ),
    }),

    onSubmit: (values, action) => {
      setProcessing(true);
      setProgress(10);
      console.log(values);
      if (!values.images) {
        toast.error("Please select a Resume");
        return;
      }
      const formData = new FormData();
      formData.append("letter_description", values.letter_description);
      formData.append("availability", values.availability);
      formData.append("images", values.images);
      server
        .post(`/internship/applyforadminternship/${data.id}`, values, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("Applied successfully");
              resetForm();
              closeModal();
              setProgress(100);
            }
            setProcessing(false);
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else if (error.response?.data?.error) {
            toast.error(error.response.data.error);
          } else {
            toast.error("Failed to connect to server");
          }
          setProcessing(false);
          setProgress(100);
        });
    },
  });

  if (!data) {
    return (
      <div>
        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <div style={{ marginTop: "1rem" }}>
        <h3 className="my-3 p-3 text-center">
          {data.position} Internship at {data.company_name}
        </h3>
        <div className="container my-4 card p-2">
          <div className="row">
            <div className="col-md-6   align-self-center">
              <h5 className="fw-bold ">{data.position}</h5>
              <p>{data.company_name}</p>
              <p>{data.internship_description}</p>
            </div>
            <div className="col-md-6 text-end">
              <img src={data.image} alt="" width={200} />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-2">
              <p>
                <b>Last Date To Apply</b>
              </p>
              <p>{data.last_date}</p>
            </div>
            <div className="col-md-2">
              <p style={{ fontSize: "15px" }}>
                <b>No Of Positions </b>
              </p>
              <p className="">{data.noofposition}</p>
            </div>
            <div className="col-md-2">
              <p>
                <b>Mode </b>
              </p>
              <p>{data.internship_mode}</p>
            </div>
            <div className="col-md-2">
              <p>
                <b>Period </b>
              </p>
              <p>{data.internship_period}</p>
            </div>
            <div className="col-md-2">
              <p>
                <b>Location</b>
              </p>
              <p>
                <a href={data.location}>View Location</a>
              </p>
            </div>
          </div>
          <div>
            {/* <button className="btn badge btn-light text-success">
              Posted 2 days ago
            </button> */}
          </div>
          <hr />
          <div>
            <h4>About {data.company_name}</h4>
            <a
              href="www.theinnovativesolutions.in"
              className="text-decoration-none"
              target="_blank"
            >
              Visit Website <BsBoxArrowUpRight />
            </a>
            {/* <p>{data.internship_description}</p> */}
          </div>
          <div>
            <h6>Skills</h6>
            <p>{data.skills}</p>
          </div>
          <button
            onClick={handleApplyNowClick}
            target="_blank"
            className="btn banner w-25 text-white my-3"
          >
            Apply Now
          </button>
        </div>
      </div>

      <Modal show={show} onHide={closeModal} size="lg">
        <Modal.Header className="bg-light" closeButton>
          <Modal.Title>
            <h5>Applying for {data.position}</h5>
            <p>{data.company_name}</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="mb-2">
              <label htmlFor="">Upload Your Resume</label>
              <input
                name="images"
                margin="dense"
                type="file"
                className="form-control"
                onChange={(event) => {
                  setFieldValue("images", event.currentTarget.files[0]);
                }}
                fullWidth
                required
              />
              {errors.images ? (
                <p className="text-danger">{errors.images}</p>
              ) : null}
            </div>
            <div className="form-outline mb-2">
              <h5> Cover Letter</h5>
              <Textarea
                minRows={4}
                name="letter_description"
                className="my-3"
                value={values.letter_description}
                onChange={handleChange}
                placeholder="Mention in detail what relevent skill or past experience you have for this internship. Why would you be a good fit?"
              />
              {errors.letter_description ? (
                <p className="text-danger">{errors.letter_description}</p>
              ) : null}
            </div>
            <div className="form-outline mb-2">
              <h5>Your availability</h5>
              <div className="form-outline mb-2">
                <FormControl>
                  <FormLabel>Confirm your availability</FormLabel>
                  <RadioGroup
                    defaultValue="outlined"
                    name="availability"
                    value={values.availability}
                    onChange={handleChange}
                  >
                    <Radio
                      value="Yes,i am available to join immediately"
                      label="Yes, I am available to join immediately"
                      variant="soft"
                    />
                    <Radio
                      value="No,i am currently on notice period"
                      label="No, I am cuurently on notice period"
                      variant="soft"
                    />
                    <Radio
                      value="No,i will have to serve notice period"
                      label="No, I will have to serve notice period"
                      variant="soft"
                    />
                    <Radio
                      value="Other(Please specify your availability)"
                      label="Other (Please specify your availability)"
                      variant="soft"
                    />
                  </RadioGroup>
                </FormControl>
                {errors.availability ? (
                  <p className="text-danger">{errors.availability}</p>
                ) : null}
              </div>
            </div>

            <button
              type="submit"
              className="my-2 banner text-white rounded-3 p-2 border-0"
            >
              Submit
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InternshipDetails;
